import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useWtrSelector } from 'redux/hooks';
import { Modal } from '@johnlewispartnership/wtr-ingredients/ingredients/Modal';

import { getSwapUnavailableProductModal } from 'redux/modules/trolley/selectors/get-swap-unavailable-product-modal';
import SubsProductList from './SubsProductList';
import UnavailableProduct from './UnavailableProduct';

import styles from './index.scss';

const SwapUnavailableProductModal = ({
  BodyButton,
  onCloseModal,
  titleText,
  subTitleText,
  productPodAddText = 'Select',
  isProductRemovable = true,
  listDefinitions,
}) => {
  const { isOpen, lineNumber, trolleyItemId } = useWtrSelector(getSwapUnavailableProductModal);

  return (
    <Modal
      className={styles.modal}
      handleModalClose={onCloseModal}
      isOpen={isOpen}
      titleText={titleText}
      contentClassName={styles['modal-content']}
    >
      <>
        <UnavailableProduct
          lineNumber={lineNumber}
          trolleyItemId={trolleyItemId}
          isProductRemovable={isProductRemovable}
          listDefinitions={listDefinitions}
        />
        <SubsProductList
          lineNumber={lineNumber}
          headingText={subTitleText}
          productPodAddText={productPodAddText}
          listDefinitions={listDefinitions}
        />
        <section className={styles.buttonWrapper}>
          <BodyButton />
        </section>
      </>
    </Modal>
  );
};

SwapUnavailableProductModal.displayName = 'SwapUnavailableProductModal';
SwapUnavailableProductModal.propTypes = {
  BodyButton: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  onCloseModal: PropTypes.func.isRequired,
  titleText: PropTypes.string.isRequired,
  subTitleText: PropTypes.string.isRequired,
  productPodAddText: PropTypes.string,
  isProductRemovable: PropTypes.bool,
  listDefinitions: PropTypes.shape({
    curation: PropTypes.string,
    format: PropTypes.string,
    page: PropTypes.string,
    title: PropTypes.string,
  }),
};

export default memo(SwapUnavailableProductModal);
